import React from "react";
import { createContext, useState, useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext/AuthContext";
import { GetHistoryThreadsService } from "../../services/Thread/ThreadService";

export const ThreadContext = createContext();
 
export const ThreadProvider = ({ children }) => {
    const [HistoryThreads, setHistoryThreads] = useState([]);
    
    const { token } = useContext(AuthContext);
  
    const GetHistoryThreads = async (companySelected) => {
        const dataHistoryThreads = await GetHistoryThreadsService(token, companySelected);
        
        if (!dataHistoryThreads["error"]) {
            setHistoryThreads([
                ...dataHistoryThreads["content"]
            ]);

            return true;
        }

        return false;
    };

    return (
        <ThreadContext.Provider value={{ HistoryThreads, setHistoryThreads, GetHistoryThreads }}>
        {children}
        </ThreadContext.Provider>
    );
};
